import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HiOutlineChevronDown } from "react-icons/hi";
import SubMenu from "./SubMenu";
import cn from "classnames";
const MegaMenuItems = ({ menuItems, selectedPageName, prevSelectedPageName, isHeaderHovered, handleClick, onEnterClick, onMouseEnter, onMouseLeave }) => {
    /**
     * Select page name is used as basis for checking which sub menu to show.
     * If the mouse is hovered on a different part of the header,
     * the previously hovered page name is used.
     */
    const isItemActive = (title) => {
        return selectedPageName === title || (isHeaderHovered && prevSelectedPageName === title);
    };
    return (_jsx("ul", { className: "header__mega-menu-list", children: menuItems.map((item, i) => {
            var _a;
            return (_jsxs("li", { className: cn("header__mega-menu-item", { "header__mega-menu-item--active": isItemActive(item.title) }), onClick: () => handleClick(item.title), onMouseEnter: () => onMouseEnter(item.title), onMouseLeave: onMouseLeave, children: [_jsx("a", { href: ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "#" : item.url, className: "header__mega-menu-title", onKeyDown: (e) => onEnterClick(e, item.title), children: item.title }), _jsx("div", { className: "px-1 lg:px-2 xl:px-3", children: item.children.length > 0 && _jsx(HiOutlineChevronDown, { className: "header__mega-menu-icon" }) }), item.children.length > 0 && _jsx(SubMenu, { menuItems: item.children, item: item, forceShow: isItemActive(item.title), featuredItems: item.featured })] }, i));
        }) }));
};
export default MegaMenuItems;
